import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9a65fa56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weights-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Adjust algorithm weights", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxIcon = _resolveComponent("PxIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("details", null, [
      _hoisted_2,
      _createElementVNode("main", null, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_3,
              _createElementVNode("th", null, [
                _createVNode(_component_PxIcon, {
                  size: 20,
                  name: "match",
                  title: "Match"
                })
              ]),
              _createElementVNode("th", null, [
                _createVNode(_component_PxIcon, {
                  size: 20,
                  name: "no-match",
                  title: "No Match"
                })
              ]),
              _createElementVNode("th", null, [
                _createVNode(_component_PxIcon, {
                  size: 20,
                  name: "unanswered",
                  title: "Unanswered"
                })
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weightNames, (weightName, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", {
                  textContent: _toDisplayString(weightName)
                }, null, 8, _hoisted_4),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.weights['matched'][index]) = $event),
                    min: "0",
                    type: "number"
                  }, null, 8, _hoisted_5), [
                    [
                      _vModelText,
                      _ctx.weights['matched'][index],
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.weights['unmatched'][index]) = $event),
                    min: "0",
                    type: "number"
                  }, null, 8, _hoisted_6), [
                    [
                      _vModelText,
                      _ctx.weights['unmatched'][index],
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.weights['unanswered'][index]) = $event),
                    min: "0",
                    type: "number"
                  }, null, 8, _hoisted_7), [
                    [
                      _vModelText,
                      _ctx.weights['unanswered'][index],
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}